import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseLocalRepository as BaseLocalRepository } from '@data/base/base-local.repository';
import { IRepository } from '@data/interfaces/ibase.repository';
import { UserEntity } from '@domain/dto/auth/auth-get.dto';
import { map, mergeMap, Observable } from 'rxjs';
import { ApiResources } from '@constants/api-resources';
import { UserMapper } from './user.mapper';
import { ResponseMessage } from '@domain/interfaces/response-message';
import { PostMessage } from '@domain/interfaces/response-post';

@Injectable()
export class UserRepository extends BaseLocalRepository implements IRepository {
  private mapper = new UserMapper();
  constructor(httpCliente: HttpClient) {
    super(httpCliente, ApiResources.USERS);
  }
  getById(id: number): Observable<UserEntity> {
    return this.getByIdRequest(id).pipe(map(this.mapper.fromJson));
  }
  get(): Observable<UserEntity> {
    return this.getRequest<UserEntity[]>()
      .pipe(mergeMap((item) => item))
      .pipe(map(this.mapper.fromJson));
  }
  post(body: UserEntity): Observable<PostMessage> {
    return this.post(body);
  }
  put(id: number, body: UserEntity): Observable<ResponseMessage> {
    return this.putRequest(id, body);
  }
  patch(id: number, body: UserEntity): Observable<ResponseMessage> {
    return this.patch(id, body);
  }
  delete(id: number): Observable<ResponseMessage> {
    return this.delete(id);
  }
}
